import { InboxOutlined, MailOutlined } from '@ant-design/icons';
import CrudGenerator from 'admin/pages/shared/CrudGenerator/CrudGenerator';
import { Button, message, Modal, Upload } from 'antd';
import Constants from 'lib/Constants';
import Cookies from 'lib/utils/Cookies';
import React, { useState } from 'react';
import './style.scss';
import { columns, formSchema } from './UserConfig';
import UserDetails from './UserDetails';
import UserService from './UserService';

const { Dragger } = Upload;

export default CrudGenerator({
    columns,
    formSchema,
    route: '/admin/users',
    entityName: {
        entityNamePlural: "Users",
        entityNameSingular: "User"
    },
    getEntities: UserService.getUsers,
    editEntity: UserService.editUsers,
    createEntity: UserService.createUser,
    deleteEntities: UserService.deleteUsers,
    modalDetails: UserDetails,

    additionalActionCTAs: (selectedRows, setSelectedRowKeys, setSelectedRows, fetchAllEntities) => {

        const [isModalVisible, setIsModalVisible] = useState(false);

        const showModal = () => {
            setIsModalVisible(true);
        };

        const handleOk = () => {
            setIsModalVisible(false);
        };

        const handleCancel = () => {
            setIsModalVisible(false);
        };

        const props = {
            name: 'file',
            multiple: false,
            action: `${process.env.API_URL}/users/patch?token=${Cookies.get(Constants.ACCESS_TOKEN)}`,
            beforeUpload: file => {
                if (file.type !== 'text/csv') {
                    message.error(`Only CSV files are supported`);
                }
                return file.type === 'text/csv' ? true : Upload.LIST_IGNORE;
            },
            onChange(info) {
                const { status } = info.file;
                if (status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (status === 'done') {
                    message.success(`${info.file.name} file uploaded successfully.`);
                    setIsModalVisible(false);
                } else if (status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
            onDrop(e) {
                console.log('Dropped files', e.dataTransfer.files);
            },
        };

        return [
            <Button key="invitation-button" disabled={selectedRows.length === 0} onClick={() => {
                UserService.triggerInvite(selectedRows.map((row) => row._id));
                setSelectedRowKeys([])
                setSelectedRows([])
                fetchAllEntities({})
            }} className="cta-button" type="default" icon={<MailOutlined />}>
                Send Invitation to Users
            </Button>,

            <Modal key="upload-modal" title="Upload File" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <Dragger {...props}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Create multiple user accounts by uploading CSV file.
                    </p>
                </Dragger>
            </Modal>

        ]
    }
})